<template>
  <naj-box
    v-if="complaint.caseNo"
    :title="local.complaints.complaintDetails.caseInfo.title"
    header-icon="mdi-format-list-bulleted-square"
    header-class="sub-header"
    disable-collapsing
  >
    <v-row>
      <v-col cols="3">
        <naj-input
          :type-id="formFieldType.text"
          :value.sync="complaint.caseNo"
          :label="local.complaints.complaintDetails.caseInfo.caseCode"
          disabled
        ></naj-input>
      </v-col>
      <v-col
        v-if="complaint.caseDateH"
        cols="3"
      >
        <naj-input
          :type-id="formFieldType.text"
          :value.sync="complaint.caseDateH"
          :label="local.complaints.complaintDetails.caseInfo.date"
          disabled
        ></naj-input>
      </v-col>
      <v-col
        v-if="complaint.caseStatus"
        cols="3"
      >
        <naj-input
          :type-id="formFieldType.text"
          :value.sync="complaint.caseStatus"
          :label="local.complaints.complaintDetails.caseInfo.status"
          disabled
        ></naj-input>
      </v-col>
      <v-col
        v-if="complaint.applyTypeName"
        cols="3"
      >
        <naj-input
          :type-id="formFieldType.text"
          :value.sync="complaint.applyTypeName"
          :label="local.complaints.complaintDetails.caseInfo.relation"
          disabled
        ></naj-input>
      </v-col>
      <v-col
        v-if="complaint.cRequestTypeName"
        cols="3"
      >
        <naj-input
          :type-id="formFieldType.text"
          :value.sync="complaint.cRequestTypeName"
          :label="local.complaints.complaintDetails.caseInfo.type"
          disabled
        ></naj-input>
      </v-col>
      <v-col
        v-if="complaint.courtName"
        cols="3"
      >
        <naj-input
          :type-id="formFieldType.text"
          :value.sync="complaint.courtName"
          :label="local.complaints.complaintDetails.caseInfo.court"
          disabled
        ></naj-input>
      </v-col>
      <v-col
        v-if="complaint.subCircleName"
        cols="3"
      >
        <naj-input
          :type-id="formFieldType.text"
          :value.sync="complaint.subCircleName"
          :label="local.complaints.complaintDetails.caseInfo.circle"
          disabled
        ></naj-input>
      </v-col>
      <v-col
        v-if="prosecutorName"
        cols="3"
      >
        <naj-input
          :type-id="formFieldType.prosecutorName"
          :value.sync="prosecutorName"
          :label="local.complaints.complaintDetails.caseInfo.prosecutorName"
          disabled
        ></naj-input>
      </v-col>

      <v-col
        v-if="defendantName"
        cols="3"
      >
        <naj-input
          :type-id="formFieldType.text"
          :value.sync="defendantName"
          :label="local.complaints.complaintDetails.caseInfo.defendantName"
          disabled
        ></naj-input>
      </v-col>
    </v-row>
  </naj-box>
</template>

<script>

export default {
  name: 'CaseDetails',
  components: {},
  props: {
    complaint: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    prosecutorName() {
      if (!this.complaint.casePartyDetailsList || this.complaint.casePartyDetailsList.length == 0)
        return null;
      return this.complaint.casePartyDetailsList.map(entry => entry.name)
        .join(',');
    },
    defendantName() {
      if (!this.complaint.casePartyAgainstDetailsList || this.complaint.casePartyAgainstDetailsList.length == 0)
        return null;
      return this.complaint.casePartyAgainstDetailsList.map(entry => entry.name)
        .join(',');
    },
  },
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
</style>
